/* eslint-disable react/prop-types */
import { useTheme } from "@mui/material";
import { Link } from "react-router-dom";

const SideBarTab = ({ label, bgColor, link, onClick, isActive }) => {
  const theme = useTheme()
  return (
    <div>
      <Link to={link} className="bg-red">
        <button
          onClick={onClick}
          className={`flex items-center justify-start w-full px-4 py-2 text-lg font-light rounded`}
          style={{ color: theme.palette.text.primary,backgroundColor: isActive ? theme.palette.secondary.light : theme.palette.primary.main}}
        >
          {label}
        </button>
      </Link>
    </div>
  );
};

export default SideBarTab;
